import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";


import { UsuariosService } from "../../servicios/usuarios.service";
import { MatTableDataSource } from '@angular/material/table';
import { MailService } from 'src/app/servicios/mail.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  displayedColumns: string[] = ['titulo','mail', 'tipo', 'actions'];
  dataSource = new MatTableDataSource();

  constructor(private userSvc:UsuariosService, private mailSvc:MailService) { }


  ngOnInit(): void {

      this.userSvc.getAllUsers().subscribe(res=>
        {
          console.log(res);
          this.dataSource.data = res;
        })

    
   }


   editar(element)
   {
     console.log(element);
     //this.mailSvc.Bienvenida()
   }

   eliminar(element)
   {
     console.log(element);
   }

}
